// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.add-assignee-item[data-v-45e82178] {\r\n  border-radius: 4px;\r\n  border: 1px solid #dcdee2;\r\n  min-height: 30px;\r\n  padding: 2px 8px;\r\n  max-height: 200px;\r\n  overflow: auto;\n}\n.add-assignee-disabled[data-v-45e82178] {\r\n  background-color: #f3f3f3;\n}\r\n", ""]);
// Exports
module.exports = exports;
